import React, {useState, useEffect, useRef} from 'react';
import MetaTags from 'react-meta-tags';  // Added Meta Tag npm Package
import { Row, Col, Card, CardBody, CardTitle,CardText, Form, Container, Button, Alert,Modal, Table, UncontrolledTooltip } from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import Select from 'react-select'

import { Link, useHistory } from "react-router-dom"
 import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";

import axios from 'axios';
import { Config, TOAST_OPTIONS, formatDate, decryptId } from "../../helpers/backend_helper"
import { SENDAPPROVALREQUEST, WQSAMPLES, WQSAMPLERLINE,WQDATA, SAMPLINGPOINTS, PARAMETERS, COMPANY, WQREPORT, APACHE_URL } from 'helpers/url_helper';

import toastr from "toastr";
import "toastr/build/toastr.min.css";

import LoadingOverlay from 'react-loading-overlay';
LoadingOverlay.propTypes = undefined
import BounceLoader from 'react-spinners/BounceLoader'
import { HRConfig } from 'helpers/backend_helper';
import { useParams } from 'react-router-dom';
import SPMap from './Maps/SPMap';


    const WQDataDetails = () => {
        const {id} = useParams()
        const inputRef = useRef(null);
        const history = useHistory();
        const [modal_line, setmodal_line] = useState(false);
        const [isEdit, setIsEdit] = useState(false)
        const [isLoading, setIsLoading] = useState(false)

        const [samplingPoint, setSamplingPoint] = useState('')
        const [samplingPointName, setSamplingPointName] = useState('')
        const [samplingDateTime, setSamplingDateTime] = useState(null)
        const [sampleNumber, setSampleNumber] = useState('')
        const [sampleComment, setSampleComment] = useState('')
        const [postedBy, setPostedBy] = useState('')
        const [sampleStatus, setSampleStatus] = useState('')

        const [resultId, setResultId] = useState('')
        const [parameterName, setParameterName] = useState('')
        const [parameter, setParameter] = useState('')
        const [type, setType] = useState('')
        const [standard, setStandard] = useState('')
        const [instrument, setInstrument] = useState('')
        const [units, setUnits] = useState('')
        const [results, setResults] = useState('')

        const [resultsList, setResultsList] = useState([])
        const [previousData, setPreviousData] = useState([])

        const [inputs, setInputs] = useState([]);
        const [isloading, setIsloading] = useState(false);
        const [userError, setUserError] = useState(true);
        const [dataSaved, setDataSaved] = useState(false)
        const [lPNo, setLPNo] = useState('')

        toastr.options = TOAST_OPTIONS;

        const [paramsList, setParamsList] = useState([]);
        const [sPointsList, setSPointsList] = useState([]);

        const [allowedToSubmit, setAllowedToSubmit] = useState(false)
        const [userId, setUserId] = useState("")
        const [approverId, setApproverId] = useState("")
        const [action, setAction] = useState('')
        const [comment, setComment] = useState('')
        
        const removeBodyCss = () => {
            document.body.classList.add("no_padding");
        }
        const tog_line = () => {
            setmodal_line(!modal_line)
            removeBodyCss()
        }
        const handleApprovalRequest = () =>{
            setIsloading(true)
            const data = {
                action  : 'request', 
                entity  : 'WQ Sample', 
                no      : sampleNumber,
                id      : decryptId(id), 
                userId  : userId
            }
            axios.post(SENDAPPROVALREQUEST, JSON.stringify(data), Config).then((r)=>{
                if(r.data.status == 1){
                    toastr.success(r.data.message)
                    fetchData()
                }else{
                    toastr.error(r.data.message)
                }
                setIsloading(false)
            }).catch((e)=>{
                console.log(e)
                setIsloading(false)
            })
        }
        const handleCancelApproval = () =>{
            setIsloading(true)
            const data = {
                action  : 'cancel', 
                entity  : 'WQ Sample',
                no      : sampleNumber,
                id      : decryptId(id), 
                userId  : userId
            }
            axios.post(SENDAPPROVALREQUEST, JSON.stringify(data), Config).then((r)=>{
                if(r.data.status == 1){
                    toastr.success(r.data.message)
                    fetchData()
                }else{
                    toastr.error(r.data.message)
                }
                setIsloading(false)
            }).catch((e)=>{
                console.log(e)
                setIsloading(false)
            })
        }
        const handleApproval = () =>{
            if(action == ""){
                toastr.error('You can select Approve or Reject Sample results')
            }else{
                if((action == "Reject") && (comment.trim().length < 4)){
                    toastr.error("Please state reason for rejecting")
                }else{
                    const data = {
                        action  : action, 
                        entity  : 'WQ Sample', 
                        no      : sampleNumber,
                        id      : decryptId(id), 
                        userId  : userId, 
                        comment : comment
                    }
                  
                    setIsloading(true)
                    axios.post(SENDAPPROVALREQUEST, JSON.stringify(data), Config).then((r)=>{
                        if(r.data.status == 1){
                            toastr.success(r.data.message)
                            history.push('/Notifications')
                        }else{
                            toastr.error(r.data.message)
                        }
                        setIsloading(false)
                    }).catch((e)=>{
                        console.log(e)
                        setIsloading(false)
                    })
                }
            }
        }
        const handleGetStandard = (c) =>{
            setIsLoading(true)
            axios.get(`${PARAMETERS}?${c}`, Config).then((r)=>{
                setIsLoading(false)
                setType(r.data[0].type)
                setUnits(r.data[0].unit)
                setStandard(r.data[0].standard)
                setInstrument(r.data[0].instrument)
                setParameterName(r.data[0].name)
                inputRef.current.focus();
                inputRef.current.setSelectionRange(inputRef.current.value.length, inputRef.current.value.length);
            }).catch((e)=>{
                console.log(e)
                toastr.error(e)
                setIsLoading(false)
            })
        }
        const handleAddResult = () =>{
            if(parameter == ""){
                toastr.error('Select parameter from the list')
            }else if(results.length < 1){
                toastr.error('Enter parameter results')
            }else{
                let data = {}
                if(isEdit){
                    data = {
                        id:resultId,
                        paramId:parameter,
                        result: results,
                        action:'update'
                    }
                    setIsloading(true)
                    axios.post(WQSAMPLERLINE, JSON.stringify(data), Config).then((r)=>{
                        setIsloading(false)
                        toastr.info(r.data.message)
                        if(r.data.status == 1){
                            fetchData()
                            tog_line()
                        }
                    }).catch((e)=>{
                        console.log(e)
                        setIsloading(false)
                    })
                }else{
                    data = {
                        sampleId:decryptId(id),
                        paramId:parameter,
                        result: results,
                        action:'add'
                    }
                    setIsloading(true)
                    axios.post(WQSAMPLERLINE, JSON.stringify(data), Config).then((r)=>{
                        setIsloading(false)
                        toastr.info(r.data.message)
                        if(r.data.status == 1){
                            fetchData()
                        }
                    }).catch((e)=>{
                        console.log(e)
                        setIsloading(false)
                    })
                }
                
            } 
        }
        const handleGenerateReport = () =>{
            
                const data = {
                    sampleId:decryptId(id)
                }
                setIsLoading(true)
                axios.post(`${WQREPORT}`, JSON.stringify(data), Config).then((r)=>{ 
                  const urlx = APACHE_URL + "attach/wqoutput.xlsx"
                  axios({
                    url: urlx,
                    method: 'GET',
                    responseType: 'blob',
                  })
                  .then((response) => {
                     const url = window.URL.createObjectURL(new Blob([response.data]));
                     const link = document.createElement('a');
                     link.href = url;
                     link.setAttribute('download', `Water-Quality-Report.xlsx`);
                     document.body.appendChild(link);
                     link.click();
                     document.body.removeChild(link);
                     window.URL.revokeObjectURL(url);
                   })
                   .catch((error) => {
                     console.error('Error downloading the file:', error);
                   });
                  setIsLoading(false)
                }).catch((e)=>{  
                  console.log(e); 
                  setIsLoading(false)
                });
              
        }
        const handleEditResult=(k)=>{
            setIsEdit(true)
            setResultId(resultsList[k].id)
            setParameter(resultsList[k].paramId)
            setType(resultsList[k].type)
            setUnits(resultsList[k].unit)
            setStandard(resultsList[k].standard)
            setInstrument(resultsList[k].instrument)
            setResults(resultsList[k].result)
            tog_line()
        }
        const clearLine = () =>{
            setResultId('')
            setParameter('')
            setType('')
            setUnits('')
            setStandard('')
            setInstrument('')
            setResults('')
        }
        const handleDeleteResult=(k)=>{
            setIsloading(true)
            const data = {id:resultsList[k].id, action:"delete"}
            axios.post(WQSAMPLERLINE, JSON.stringify(data), Config).then((r)=>{
                setIsloading(false)
                toastr.warning(r.data.message)
                fetchData()
            }).catch((e)=>{
                console.log(e)
                setIsloading(false)
            })
        }
        const fetchData = () => {
            setIsloading(true)
            axios.get(SAMPLINGPOINTS, Config).then((r)=>{ setSPointsList(r.data);  }).catch((e)=>{  console.log(e); });
            axios.get(PARAMETERS, Config).then((r)=>{ setParamsList(r.data);  }).catch((e)=>{  console.log(e); });
            const data = {
                id: decryptId(id),
                sDate: '',
                eDate: '',
                sPoint: '',
                sStaff: '' 
            }
            axios.post(WQSAMPLES, JSON.stringify(data), Config).then((r)=>{ 
                setIsloading(false); 
                setSamplingPoint(r.data[0].pointId)
                setSamplingPointName(r.data[0].point)
                setSamplingDateTime(new Date(r.data[0].date))
                setSampleNumber(r.data[0].sample)
                setSampleComment(r.data[0].comment)
                setPostedBy(r.data[0].postedBy)
                setSampleStatus(r.data[0].status)
                setResultsList(r.data[0].sampleData)
                setApproverId(r.data[0].approverId)
    
                const data = { id  : '', sDate: '', eDate: '', sPoint: r.data[0].pointId, sStaff: '' }
                axios.post(WQSAMPLES, JSON.stringify(data), Config).then((rr)=>{ setPreviousData(rr.data) }).catch((ee)=>{  console.log(ee); });
            }).catch((e)=>{  console.log(e); setIsloading(false); });
            if(localStorage.getItem("authWTUser")){
                const obj = JSON.parse(localStorage.getItem("authWTUser"));
                setUserId(obj.id);
            } 
        }
        
        useEffect(() => {
         fetchData();
        },[]);

        const handleUpdateSample = () =>{
            const data = {
                id          : decryptId(id),
                dateTime    : `${samplingDateTime.toISOString().slice(0, 19).replace('T', ' ')}`,
                number      : sampleNumber,
                comment     : sampleComment,
                action      : 'update'
            }
           
            setIsloading(true)
            axios.post(WQDATA, JSON.stringify(data), Config)
            .then((r)=>{
                toastr.success(r.data.message);
                fetchData() 
                setIsloading(false)
            })
            .catch((e)=>{
                console.log(e);
                setIsloading(false)
            });
            
        }
  
        const handleDelete = () =>{
            const data = {
                "id"        : decryptId(id),
                "action"    : 'delete'
            }
            setIsloading(true)
            axios.post(`${WQDATA}`, JSON.stringify(data), Config).then((r)=>{
                toastr.warning(r.data.message)
                history.push(`/Water-Sampling`)
                setIsloading(false)
            }).catch((e)=>{
                console.log(e)
                setIsloading(false)
            })
        }
  
        
        return (
            <>
            <LoadingOverlay
                active={isloading}
                spinner={<BounceLoader />}
                text='Please wait...'
                >
                <div className="page-content">
                    <MetaTags>
                    <title>Water sampling data | {COMPANY}</title>
                    </MetaTags>
                    <Container fluid={true}>
                        <Breadcrumbs title={COMPANY} breadcrumbItem={samplingPointName} />
                        <div>
                       

                        {(dataSaved == false) ? (
                        <Row>
                        <Col xl={12}>
                        <Card>
                        <h5 className="card-header bg-transparent border-bottom text-uppercase">Sample</h5>
                            <CardBody>
                                    <Row className='mt-4 mb-4'>
                                    <Col md={4}>
                                        <div className="mb-3">
                                        <label>Sampling Point</label>
                                        <select className="form-select" value={samplingPoint} onChange={(e)=>setSamplingPoint(e.target.value)} disabled={true}>
                                        <option value=""> Select</option>
                                        { sPointsList && (sPointsList.length > 0) && (
                                            sPointsList.map((p,k)=>(
                                                <option key={k} value={p.id}>{p.name} - {p.type}</option>
                                            ))
                                        )}
                                            </select>
                                        
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="mb-3">
                                        <label>Sampling Date and Time</label>
                                                <Flatpickr
                                                    className="form-control"
                                                    options={{
                                                        mode: 'single',
                                                        dateFormat: "Y-m-d H:i",
                                                        enableTime: true,
                                                        time_24hr: false
                                                    }}
                                                    disabled={(sampleStatus == 'Open')?false:true}
                                                    value={samplingDateTime}
                                                    onChange={(dateTime)=>{setSamplingDateTime(dateTime[0] || null)}}
                                                    />
                                                
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="mb-3">
                                        <label>Sample Number</label>
                                                <input  type='text' className="form-control" value={sampleNumber} onChange={(e)=>setSampleNumber(e.target.value)} disabled={(sampleStatus == 'Open')?false:true}/>
                                                
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="mb-3">
                                        <label>Posted By</label>
                                                <input  type='text' className="form-control" value={postedBy} onChange={(e)=>setPostedBy(e.target.value)} disabled={true}/>
                                                
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="mb-3">
                                        <label>Sample Status</label>
                                                <input  type='text' className="form-control" value={sampleStatus} onChange={(e)=>setSampleStatus(e.target.value)} disabled={true}/>
                                                
                                        </div>
                                    </Col>
                                    </Row>
                                </CardBody>
                            </Card>

                            

                                <Modal isOpen={modal_line} toggle={() => { tog_line(); }}  size="l" centered  backdrop={'static'}  >
                                  <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">{ isEdit? `Update Results`:`Add Results` }</h5>
                                    <button type="button"  onClick={() => { setmodal_line(false);  }}  className="close" data-dismiss="modal"aria-label="Close">
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                   <Row>
                                   <Col lg={6} className="mb-3">
                                        <div className="mb-3">
                                        <label>Parameter</label>
                                        <select className="form-select" value={parameter} onChange={(e)=>{setParameter(e.target.value); handleGetStandard(e.target.value)}}>
                                            <option value=""></option>
                                            {(paramsList || []).map((formRow, key) => (
                                                <option value={formRow.id} key={key} >{formRow.name}</option>
                                            ))}
                                        </select>
                                        
                                        </div>
                                    </Col>
                                    <Col md={6}>
                                        <div className="mb-3">
                                            <label>Type</label>
                                            <input  type='text' className="form-control" disabled={true} defaultValue={type} />    
                                        </div>
                                    </Col>
                                    <Col md={6}>
                                        <div className="mb-3">
                                            <label>Instrument</label>
                                            <input  type='text' className="form-control" disabled={true} defaultValue={instrument} />    
                                        </div>
                                    </Col>
                                    <Col md={6}>
                                        <div className="mb-3">
                                            <label>Standard</label>
                                            <input  type='text' className="form-control" disabled={true} defaultValue={standard} />    
                                        </div>
                                    </Col>
                                    <Col md={6}>
                                        <div className="mb-3">
                                            <label>Results</label>
                                            <input  type='text' className="form-control" ref={inputRef} value={results} onChange={(e)=>setResults(e.target.value)}/>    
                                        </div>
                                    </Col>
                                    <Col md={6}>
                                        <div className="mb-3">
                                            <label>Units</label>
                                            <input  type='text' className="form-control" disabled={true} defaultValue={units} />    
                                        </div>
                                    </Col>
                                    
                                   </Row>
                                  </div>
                                  <div className="modal-footer justify-content-end">
                                  <button type="button" className="btn btn-danger me-2" onClick={()=>tog_line()} >Cancel</button> 
                                    {(isLoading ? 
                                            (<button type="button" className="btn btn-secondary" disabled={true}>Please wait...</button>)
                                        : ( <button type="button" className="btn btn-success" onClick={handleAddResult}>Save results...</button> ))
                                    }</div>
                                </Modal>
                            <Row>
                            <Col lg={8}>
                            <Card>
                            <h5 className="card-header bg-transparent border-bottom text-uppercase">Results</h5>
                                <CardBody>
                     
                                
                                <div>
                                {(resultsList.length > 0) ? (
                                            <div className="table-responsive">
                                                <Table className="table table-striped table-sm mb-4">
                                                    <thead>
                                                        <tr>
                                                            <th>Parameter</th>
                                                            <th>Type</th>
                                                            {/*<th>Instrument</th>*/}
                                                            <th>Standard</th>
                                                            <th>Units</th>        
                                                            <th>Results</th>
                                                            <th></th>
                                                            
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                      	                {resultsList.map((a,k)=>(
                                                            <tr key={k}>
                                                                <td>{a.param}</td>
                                                                <td>{a.type}</td>
                                                                {/*<td>{a.instrument}</td>*/}
                                                                <td>{a.standard}</td>
                                                                <td>{a.unit}</td>
                                                                <td>{a.result}</td>
                                                                <td style={{ verticalAlign: 'middle', textAlign: 'center' }}> 
                                                                {(sampleStatus == 'Open') && (
                                                                <>
                                                                    <div className="d-flex gap-3">
                                                                        <Link
                                                                        to="#"
                                                                        className="text-success"
                                                                        onClick={() => handleEditResult(k)}
                                                                        >
                                                                        <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                                                                        <UncontrolledTooltip placement="top" target="edittooltip">
                                                                            Edit
                                                                        </UncontrolledTooltip>
                                                                        </Link>
                                                                        <Link
                                                                        to="#"
                                                                        className="text-danger"
                                                                        onClick={() => handleDeleteResult(k)}
                                                                        >
                                                                        <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                                                                        <UncontrolledTooltip placement="top" target="deletetooltip">
                                                                            Delete
                                                                        </UncontrolledTooltip>
                                                                        </Link>
                                                                    </div>
                                                                    </>)}</td>
                                                               
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </Table>
                                                </div>
                                            ):(
                                                <div className="text-center">
                                                    <div className="mb-4">
                                                    <i className="mdi mdi-check-circle-outline text-warning display-4" />
                                                    </div>
                                                    <div>
                                                    <h5>No data yet</h5>
                                                    <p className="text-muted">
                                                            
                                                    </p>
                                                    </div>
                                                </div>
                                            )}
                                        <Row>
                                            <Col lg={12} className="mb-3">
                                                <div className="mb-3">
                                                <label>Comment</label>
                                                <textarea className="form-control" disabled={(sampleStatus == "Open")?false:true} value={sampleComment} onChange={(e)=>setSampleComment(e.target.value)} />
                                                </div>
                                            </Col>
                                        </Row>
                     
                                        </div>
                                           {(sampleStatus == "Open") && (
                                                <Row className=' mb-4 mt-4 justify-content-center'>
                                                   <Col md={3}>
                                                        <div className="d-grid gap-2">
                                                            <Button
                                                                color="success"
                                                                className="btn btn-rounded"
                                                                onClick={() => { setIsEdit(false); clearLine(); tog_line(); }}
                                                                >
                                                                Add results
                                                            </Button>
                                                        </div>
                                                    </Col>
                                                    <Col md={3}>
                                                        <div className="d-grid gap-2">
                                                            <Button
                                                                color="warning"
                                                                className="btn btn-rounded"
                                                                onClick={() => { handleUpdateSample(); }}
                                                                >
                                                                Update header
                                                            </Button>
                                                        </div>
                                                    </Col>
                                                    <Col md={3}>
                                                        <div className="d-grid gap-2">
                                                            <Button color="danger" type="button" className="btn btn-rounded" onClick={handleDelete}>
                                                                Delete 
                                                            </Button>
                                                        </div>
                                                    </Col>
                                                    <Col md={3}>
                                                        <div className="d-grid gap-2">
                                                            <Button color="info" type="button" className="btn btn-rounded" onClick={handleApprovalRequest}>
                                                                Send for Approval
                                                            </Button>
                                                        </div>
                                                    </Col>
                                                </Row>
                                                )}
                                                {(sampleStatus == 'Pending Approval') && allowedToSubmit && (
                                                        <Row className=' mb-4 mt-4 justify-content-center'>
                                                            <Col md={5} className='mb-3'>
                                                                <div className="d-grid gap-2">
                                                                    <Button color="danger" className="btn btn-rounded" onClick={handleCancelApproval} >
                                                                        Cancel Approval Request
                                                                    </Button>
                                                                </div>
                                                            </Col>
                                                        
                                                        </Row>
                                                )}
                                                <Row className=' mb-4 mt-4 justify-content-center'>
                                                   <Col md={6}>
                                                        <div className="d-grid gap-2">
                                                            <Button
                                                                color="primary"
                                                                className="btn btn-rounded"
                                                                onClick={handleGenerateReport}
                                                                >
                                                                Generate Report
                                                            </Button>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </CardBody>
                                        </Card>
                                        {(sampleStatus == 'Pending Approval') && (userId == approverId) && (
                                        <Card>
                                        <h5 className="card-header bg-transparent border-bottom text-uppercase">Approve/Reject (You are the approver)</h5>
                                            <CardBody>
                                                <Row className="mb-2 mt-3 justify-content-center">
                                                    <Col md={10} className='mb-2'>
                                                        <div className="mb-3">
                                                            <label>Action</label>
                                                            <select className="form-select" value={action} onChange={(e)=>setAction(e.target.value)}>
                                                                <option value=""></option>
                                                                <option value="Approve">Approve</option>
                                                                <option value="Reject">Reject</option>
                                                            </select>
                                                        </div>
                                                    </Col>
                                                    <Col md={10} className='mb-2'>
                                                        <div className="mb-3">
                                                            <label>Comment</label>
                                                            <textarea className="form-control" value={comment} onChange={(e)=>setComment(e.target.value)} />
                                                        </div>
                                                    </Col>
                                                    <Col md={6} className='mb-3'>
                                                        <div className="d-grid gap-2">
                                                            <Button color="primary" className="btn" onClick={handleApproval}>
                                                                Submit response...
                                                            </Button>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </CardBody>
                                        </Card>
                                      )} 
                                        <Card>
                                        <h5 className="card-header bg-transparent border-bottom text-uppercase">Previous data</h5>
                                <CardBody>
                           
                                
                                
                                <div>
                                {(previousData.length > 0) ? (
                                            <div className="table-responsive">
                                            <Table className="table table-striped table-sm mb-4">
                                                    <thead>
                                                        <tr>
                                                            
                                                            <th>Date</th>
                                                            <th>Point</th>
                                                            <th style={{ textAlign: 'center' }}>Sample</th>
                                                            <th style={{ textAlign: 'center' }}>Parameters</th>
                                                            <th>Posted by</th>
                                                            
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                      	                {previousData.map((a,k)=>(
                                                            <tr key={k}>
                                                                <td>{a.date}</td>
                                                                <td>{a.point}</td>
                                                                <td style={{ textAlign: 'center' }}>{a.sample}</td>
                                                                <td style={{ textAlign: 'center' }}>{a.sampleData.length}</td>
                                                                <td>{a.postedBy}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </Table>
                                                </div>
                                            ):(
                                                <div className="text-center">
                                                    <div className="mb-4">
                                                    <i className="mdi mdi-check-circle-outline text-danger display-4" />
                                                    </div>
                                                    <div>
                                                    <h5>No previous data</h5>
                                                    <p className="text-muted">
                                                            
                                                    </p>
                                                    </div>
                                                </div>
                                            )}
                                            </div>
                                </CardBody>
                            </Card>
                            </Col><Col lg="4">
                            <Card>
                                <CardBody>
                                <h5 className="card-header bg-transparent border-bottom text-uppercase">LOCATION</h5>
                                
                                 <SPMap/>


                               
                                </CardBody>
                            </Card>
                            </Col>
                            </Row>    
                                 
                    
                        </Col>
                        
                        </Row>
                        ):(
                            <Row className="d-flex justify-content-center">
                                <Col lg={8} >
                                <Card outline color="success" className="border">
                                    <CardBody>
                                    <CardTitle className="mb-4 text-white">
                                        
                                    </CardTitle>
                                    <CardText>
                                        
                                    </CardText>
                                    <div className="text-center">
                                        <div className="mb-4">
                                        <i className="mdi mdi-check-circle-outline text-success display-4" />
                                        </div>
                                        <div>
                                        <h5>Saved</h5>
                                        <p className="text-muted">
                                                 <strong>WQ Data Saved</strong>
                                        </p>
                                        </div>
                                    </div>
                                    </CardBody>
                                </Card>
                                </Col>
                            </Row>
                        )}
                        </div>


                    </Container>
                    
                       
                    
                </div>
                </LoadingOverlay>
            </>
        );
    }

export default WQDataDetails;